// ---------------------------------------------------------------------------
// AI rationale lookup — the backend returns `aiSuggestions` as a flat array
// keyed by workItemId. Components that render per-item UI look up their
// rationale by id, so a small map helper keeps that correlation trivial.
// ---------------------------------------------------------------------------

import type { AiItemRationale, StartMyDayResponse } from '../types/models';

export interface RationaleEntry {
  rationale?: string;
  strategyLink?: string;
}

/**
 * Build a { workItemId → rationale } map from a StartMyDayResponse. Safe to
 * call with null / undefined input — returns an empty map.
 */
export function buildRationaleMap(
  data: StartMyDayResponse | null | undefined,
): Map<string, RationaleEntry> {
  const map = new Map<string, RationaleEntry>();
  if (!data?.aiSuggestions) return map;
  for (const suggestion of data.aiSuggestions as AiItemRationale[]) {
    if (!suggestion.workItemId) continue;
    if (!suggestion.rationale && !suggestion.strategyLink) continue;
    map.set(suggestion.workItemId, {
      rationale: suggestion.rationale ?? undefined,
      strategyLink: suggestion.strategyLink ?? undefined,
    });
  }
  return map;
}
